<template>
  <v-layout row wrap class="mt-5 mb-2">
      <v-flex
          xs12
          sm12
          offset-sm0
          md10
          lg8
          offset-md1
          offset-lg2
          class="pa-0"
        >
      <v-layout
        align-center
        justify-space-around
        row wrap
      >
        <div class="text-xs-center display-1 mb-3" style="min-width: 220px;">
          <strong>{{ this.stats.betriebe }}</strong><br> Fachbetriebe
        </div>
        <div class="text-xs-center display-1 mb-3" style="min-width: 220px;"><strong>{{ stats.innungen }}</strong> <br>Innungen</div>
        <div class="text-xs-center display-1" style="min-width: 220px;"><strong>{{ stats.staedte }}</strong> <br>Städte</div>
      </v-layout> 
    </v-flex>
    </v-layout>
</template>
  
<script>

export default {
  data: () => ({
   // stats: ''
  }),
  props: ['stats'],
  metaInfo () {
    return {
      title: 'Handwerker aus Innungsfachbetrieben in Ihrer Stadt finden',
      meta: [
         { name: 'description', content: this.metaDescriptionText }
      ],
      script: [{
        type: 'application/ld+json',
        json: {
          '@context': 'http://schema.org',
          '@type': 'Organization',
          name: 'LokalesHandwerk.de GmbH',
          address: {
            '@type': 'PostalAddress',
            'addressCountry': 'DE',
            'addressRegion': 'NRW',
            'addressLocality': 'Essen',
            'postalCode': '45141',
            'streetAddress': 'Katzenbruchstr. 71'
          },
          email: 'info@lokaleshandwerk.de',
          parentOrganization: 'Kreishandwerkerschaften',
          logo: 'https://www.lokaleshandwerk.de/img/logo_mini_trans.png',
          url: 'https://www.lokaleshandwerk.de'
        }
      }]
    }
  },
  computed: {
    metaDescriptionText: function () {
      if (this.stats) {
        if (this.stats.betriebe) {
          return this.stats.betriebe + ' Fachbetriebe aus ' + this.stats.innungen + ' Innungen in ' + this.stats.staedte + ' Städten. Finden Sie den richtigen lokalen Handwerker auf der Plattform der Kreishandwerkerschaften.'
        }
      } else {
        return 'Über 10000 Fachbetriebe aus 150+ Innungen. Finden Sie den richtigen lokalen Handwerker auf der Plattform der Kreishandwerkerschaften.'
      }
    }
  }
}
</script>

<style>
</style>